import React from "react";
import { useFormContext } from "react-hook-form";
import { Props as ReactSelectProps } from "react-select";
import { SelectOption } from "../../../../../types/select";
import { ReactSelectField } from "../../../../atoms/FormElement";
import { getSelectPlaceholderMessage } from "../../../../libs/form";

type InvoicingPatternSelectProps = Pick<ReactSelectProps, "isDisabled">;

export const invoicingPatternOptions: SelectOption[] = [
  { label: "At beginning of lease", value: "atBeginningOfLease" },
  { label: "At each due date", value: "atEachDueDate" },
];

export const InvoicingPatternSelect = (props: InvoicingPatternSelectProps) => {
  const { isDisabled } = props;

  const { control, setValue, formState } = useFormContext();

  const label = "Invoicing Pattern";
  const invoicingPatternError = formState?.errors?.invoicingPattern;

  return (
    <ReactSelectField
      isRequired
      control={control}
      setValue={setValue}
      label={label}
      fieldname="invoicingPattern"
      selectOption={invoicingPatternOptions}
      isDisabled={isDisabled}
      iProps={{ placeholder: getSelectPlaceholderMessage(label) }}
      validate={invoicingPatternError && "error"}
      validMessage={invoicingPatternError?.message}
    />
  );
};
